import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { YardMapComponent } from './component/yardmap.component';



@NgModule({
  declarations: [
    YardMapComponent
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    YardMapComponent
  ]
})
export class YardMapModule { }
